// Shared leagues configuration used across Sports pages
// Source of truth for all league definitions

// TheSportsDB v1 (paid key — unlocks higher rate limits)
const isDev = process.env.NODE_ENV === "development";

export const THESPORTSDB_KEY = "223753";
export const THESPORTSDB_BASE = isDev
  ? "/thesportsdb-api/"
  : `https://www.thesportsdb.com/api/v1/json/${THESPORTSDB_KEY}/`;
export const API_SPORTS_KEY = "50b71acfe2fa82c70a5a5014b5dea076";

// API-Sports proxy bases (dev proxy avoids CORS)
export const API_FOOTBALL_BASE = isDev
  ? "/api-football"
  : "https://v3.football.api-sports.io";
export const API_AMERICAN_FOOTBALL_BASE = isDev
  ? "/api-american-football"
  : "https://v1.american-football.api-sports.io";
export const API_BASKETBALL_BASE = isDev
  ? "/api-basketball"
  : "https://v1.basketball.api-sports.io";
export const API_HOCKEY_BASE = isDev
  ? "/api-hockey"
  : "https://v1.hockey.api-sports.io";
export const API_BASEBALL_BASE = isDev
  ? "/api-baseball"
  : "https://v1.baseball.api-sports.io";

export const SPORT_ICONS = {
  "American Football": "fas fa-football-ball",
  "College Football": "fas fa-football-ball",
  Basketball: "fas fa-basketball-ball",
  "Ice Hockey": "fas fa-hockey-puck",
  Baseball: "fas fa-baseball-ball",
  Soccer: "fas fa-futbol",
  Motorsport: "fas fa-flag-checkered",
  Fighting: "fas fa-fist-raised",
  Rugby: "fas fa-football-ball",
};

export const SPORT_NEWS_KEYS = {
  "American Football": "nfl",
  "College Football": "ncaaf",
  Basketball: "nba",
  "Ice Hockey": "nhl",
  Baseball: "mlb",
  Soccer: "soccer",
  Rugby: "all",
  Motorsport: "all",
  Fighting: "all",
};

export const LEAGUES = [
  // American Sports (API-Sports)
  {
    id: "nfl",
    name: "NFL",
    sport: "American Football",
    apiType: "apisports",
    sportsDbId: 4391,
  },
  {
    id: "ncaaf",
    name: "NCAAF",
    sport: "College Football",
    apiType: "apisports",
    sportsDbId: 4479,
  },
  {
    id: "nba",
    name: "NBA",
    sport: "Basketball",
    apiType: "apisports",
    sportsDbId: 4387,
  },
  {
    id: "nhl",
    name: "NHL",
    sport: "Ice Hockey",
    apiType: "apisports",
    sportsDbId: 4380,
  },
  {
    id: "mlb",
    name: "MLB",
    sport: "Baseball",
    apiType: "apisports",
    sportsDbId: 4424,
  },
  // Soccer Leagues (API-Sports)
  {
    id: "39",
    name: "Premier League",
    sport: "Soccer",
    apiType: "apisports",
    leagueId: 39,
    sportsDbId: 4328,
  },
  {
    id: "140",
    name: "La Liga",
    sport: "Soccer",
    apiType: "apisports",
    leagueId: 140,
    sportsDbId: 4335,
  },
  {
    id: "78",
    name: "Bundesliga",
    sport: "Soccer",
    apiType: "apisports",
    leagueId: 78,
    sportsDbId: 4331,
  },
  {
    id: "135",
    name: "Serie A",
    sport: "Soccer",
    apiType: "apisports",
    leagueId: 135,
    sportsDbId: 4332,
  },
  {
    id: "61",
    name: "Ligue 1",
    sport: "Soccer",
    apiType: "apisports",
    leagueId: 61,
    sportsDbId: 4334,
  },
  {
    id: "94",
    name: "Portuguese Liga",
    sport: "Soccer",
    apiType: "apisports",
    leagueId: 94,
    sportsDbId: 4344,
  },
  {
    id: "253",
    name: "MLS",
    sport: "Soccer",
    apiType: "apisports",
    leagueId: 253,
    sportsDbId: 4346,
  },
  // Other Sports
  {
    id: "motorsport",
    name: "Motorsport",
    sport: "Motorsport",
    apiType: "thesportsdb",
    leagueId: null,
    sportsDbId: null,
  },
  {
    id: "fighting",
    name: "Fighting",
    sport: "Fighting",
    apiType: "thesportsdb",
    leagueId: null,
    sportsDbId: null,
  },
  {
    id: "rugby",
    name: "Rugby",
    sport: "Rugby",
    apiType: "apisports",
    leagueId: 1,
    sportsDbId: null,
  },
];

// Group leagues by sport category for the Leagues browser page
export const LEAGUE_GROUPS = [
  {
    label: "Soccer",
    icon: "fas fa-futbol",
    leagues: LEAGUES.filter((l) => l.sport === "Soccer"),
  },
  {
    label: "American Sports",
    icon: "fas fa-football-ball",
    leagues: LEAGUES.filter((l) =>
      [
        "American Football",
        "College Football",
        "Basketball",
        "Ice Hockey",
        "Baseball",
      ].includes(l.sport)
    ),
  },
  {
    label: "Other",
    icon: "fas fa-trophy",
    leagues: LEAGUES.filter((l) =>
      ["Motorsport", "Fighting", "Rugby"].includes(l.sport)
    ),
  },
];
